export default {
  id: 13,
  title: 'Target #13 - Totally Triangle',
  url: 'https://cssbattle.dev/play/13',
  colors: ['#0B2429', '#F3AC3C'],
  solution:
    '<a><style>body{background:#0B2429}a{position:fixed;top:0;left:0;border:70px solid #F3AC3C;border-bottom-color:transparent;border-right-color:transparent}</style>',
}
